export default __webpack_public_path__ + "static/media/down-arrow.f44a2550.svg";